<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">

            <a-form-item label="产品名称" name="productName">
                <a-input v-model:value="searchForm.productName" placeholder="请输入产品名称" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">

            <template #img="{record}">
                <div  style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.img" :showList="true" disabled />
                </div>
            </template>
            <template #productName="{record}">
                <a @click="onDetail(record)">{{record.productName}}</a>
            </template>
            <template #type="{text}">
                <dict-render :dict-obj="dictObjs['loanType']" :text="text"></dict-render>
            </template>
            <template #guarantyType="{ text }">
                <dict-render :dict-obj="dictObjs['guarantee']" :text="text"></dict-render>
            </template>
            <template #loanDeadline="{ text }">
                <dict-render :dict-obj="dictObjs['loanDeadline']" :text="text"></dict-render>
            </template>
            <template #paymentType="{ text }">
                <dict-render :dict-obj="dictObjs['paymentType']" :text="text"></dict-render>
            </template>
            <template #publish="{ record }">
                <CheckOutlined v-if="record.publish == 0" style="color: #1aad19"/>
                <CloseOutlined v-if="record.publish == 1" style="color: red"/>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a v-if="record.publish==1" @click="onEdit(record)">编辑</a>
                    <a v-else @click="onDetail(record)">查看</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import Detail from "./components/Detail";
import {tableListMixin, dictMixin} from "@/mixins";
import {financeProduct} from "@/api/finance";
import DictRender from "@/components/other/DictRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "主图", dataIndex: "img", key: "img", slots: {customRender: "img"}},
    {title: "产品名称", dataIndex: "productName", key: "productName", slots: {customRender: "productName"}},
    {title: "最高贷款金额(万元)", dataIndex: "maxLoanLines", key: "maxLoanLines"},
    {title: "贷款利率(%)", dataIndex: "rate", key: "rate"},
    // {title: "担保方式", dataIndex: "guarantyType", key: "guarantyType", slots: {customRender: "guarantyType"}},
    {title: "贷款期", dataIndex: "loanDeadline", key: "loanDeadline", slots: {customRender: "loanDeadline"}},
    {title: "还款方式", dataIndex: "paymentType", key: "paymentType", slots: {customRender: "paymentType"}},
    // {title: "类型", dataIndex: "type", key: "type", slots: {customRender: "type"}},
    {title: "发布", dataIndex: "publish", key: "publish", slots: {customRender: "publish"}},
    {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "金融产品申请",
    mixins: [tableListMixin,dictMixin],
    components: {
        AddOrEditModal,
        DictRender,
        Detail
    },
    data() {
        return {
            dictNames: 'guarantee,loanDeadline,paymentType,loanType',
            columns,
            queryParam: {},
            listUrl: financeProduct.pageList,
            listKeyField: "id",
            deleteUrl: financeProduct.remove
        }
    },
    methods: {
        // onAdd() {
        //     this.getAction({
        //         url: sys_admin.userInfor
        //     }).then(res => {
        //         this.onShowModal('modal',{guarantyType:res.id});
        //     })
        // },
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeProduct.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

        onDetail(record){
            this.getAction({
                url: financeProduct.detail,
                params: {id: record.id}
            }).then(res=>{
                this.onShowModal("detailmodal", res)
            })
        }
    }
}
</script>

<style scoped>

</style>
